export const ClockIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="30"
    height="30"
    viewBox="0 0 30 30"
  >
    <title> clock </title>
    <path
      fillRule="evenodd"
      d="M15 26c6.075 0 11-4.925 11-11S21.075 4 15 4 4 8.925 4 15s4.925 11 11 11zM5 15C5 9.4772 9.4772 5 15 5s10 4.4772 10 10-4.4772 10-10 10S5 20.5228 5 15zm14 2h-5v-7h1v6h4v1z"
    ></path>
  </svg>
);
